<!-- 삭제 -->
<template>
  <div>
    <admin-box-item title="복제" :useTab="false">
      <div>복제하시겠습니까?</div>
      <div class="btn-group-justify-end">
        <button class="button is-light" @click="cancelModal">취소</button>
        <button class="button is-primary" @click="confirmModal">확인</button>
      </div>
    </admin-box-item>
  </div>
</template>

<script>
  export default {
    props:['data'],
    components: {
    },
    data () {
      return {
        value: {
          url: ''
        }
      }
    },
    created(){
      this.value = this.data;
    },
    watch:{
      data(n){
        if(n){
          this.value = n;
        }
      }
    },
    methods: {
      cancelModal(){
        this.$store.commit('cancelModal');
      },
      confirmModal(){

        this.$axios.post(this.getUrl(this.value.url)).then(res=>{
          if(res.status===200){
            this.toast('완료되었습니다.');
            this.$store.commit('closeModal');
          }
        })
      }
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>


</style>
